import { useEffect } from 'react';
import { createDateDefaultValue } from '../constants/common';
import { filterNames } from '../constants/filterNames';
import { filtersData } from '../constants/filtersData';
import useFilterState from './useFilterState';

const useSetDefaultFilter = () => {
  const [createDateFilter, setCreateDateFilter] = useFilterState(
    filtersData[filterNames.createDate]
  );

  useEffect(() => {
    if (createDateFilter.length === 0) {
      setCreateDateFilter(createDateDefaultValue);
    }
  }, []);
};

export default useSetDefaultFilter;
